/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Adduptothreemetrics8Inputs */

const en_coinvestments_lpdealoverviewcontent_adduptothreemetrics8 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Adduptothreemetrics8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add up to three metrics`)
};

/**
* | output |
* | --- |
* | "Add up to three metrics" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Adduptothreemetrics8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_adduptothreemetrics8 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Adduptothreemetrics8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Adduptothreemetrics8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_adduptothreemetrics8(inputs)
});
export { coinvestments_lpdealoverviewcontent_adduptothreemetrics8 as "coInvestments_lpDealOverviewContent_addUpToThreeMetrics" }